import React from "react";
import { Box, Typography } from "@mui/material";
import theme from "../../../theme";

interface Props {}

const Footer: React.FC<Props> = () => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: theme.palette.background.paper,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          position: "fixed",
          bottom: 0,
          width: "100%",
          paddingY: "2px",
          paddingX: 1,
          zIndex: (theme) => theme.zIndex.drawer - 1,
          height: "35px",
        }}
      >
        <Typography variant="caption" color="textPrimary" fontWeight="400">
          COPYRIGHT {new Date().getFullYear()}
        </Typography>
        <img height={45} src={"/static/images/SVPro_Detector.png"} alt="logo" />
        <Box></Box>
      </Box>
    </>
  );
};

export default Footer;
